/** The card's one action bar, pinned under it: a sentence saying where the player is and the single primary button (DESIGN §2). */
import type { ReactNode } from "react";
import { GxStickyBar } from "../theme/GxStickyBar";

export interface BarAction { readonly label: string; readonly onClick: () => void; readonly disabled: boolean; /** "accent" = gold, the call to act; "navy" = move on. */ readonly tone: "accent" | "navy"; readonly testId?: string }

export function ActionBar({ sentence, sentenceId = "event.bar.sentence", aside, action }: { readonly sentence: ReactNode; readonly sentenceId?: string; readonly aside?: ReactNode; readonly action: BarAction | null }) {
  return (
    <GxStickyBar className="gx-ev-bar" testId="event.bar" lead={<span role="status" data-testid={sentenceId}>{sentence}</span>}>
      {aside === undefined ? null : <span className="gx-small gx-faint">{aside}</span>}
      {action === null ? null : <button type="button" className={`gx-btn ${action.tone === "accent" ? "gx-btn--accent" : "gx-btn--primary"}`} data-testid={action.testId ?? "event.bar.action"} disabled={action.disabled} onClick={action.onClick}>{action.label}</button>}
    </GxStickyBar>
  );
}
